export default __webpack_public_path__ + "static/media/static.70989553.svg";